import { useState } from "react";
import classNames from "classnames";
import { withAppStore } from "../../../context";

export default withAppStore(
  ({
    onChange,
    options,
    value,
    styleSwitch = "switch--noneBorder",
    gap = 0,
  }) => {
    const position = () => {
      let percent = -1;
      options.forEach((item, index) => {
        if (item.value === value) {
          percent = index;
        }
      });
      return `calc(${percent}00% + ${gap * percent}px)`;
    };

    return (
      <div
        className={classNames("switch", styleSwitch, {
          "switch--null": value === null,
          "switch--gap": gap !== 0,
        })}
        style={{
          gap: `${gap}px`,
        }}
      >
        {options.map((item, index) => (
          <button
            key={`key-${value}-${item.value}-${index}`}
            onClick={() => {
              onChange(item.value);
            }}
            disabled={(item.value === value ? "disabled" : "") || item.disabled}
            style={{
              outline: `${gap}px solid #fff`,
            }}
            className={classNames("switch__btn", {
              "switch__btn--active": item.value === value,
              "switch__btn--firstChild": index === 0,
              "switch__btn--lastChild": index === options.length - 1,
            })}
          >
            {item.label}
          </button>
        ))}
        {styleSwitch.includes("switch--vertical") ? (
          <span
            className={classNames("switch__bg")}
            style={{
              transform: `translateY(${position()})`,
              // height: `calc(100% / ${options.length})`,
            }}
          />
        ) : (
          <span
            className={classNames("switch__bg")}
            style={{
              transform: `translateX(${position()})`,
              width: `calc(${100 / options.length}% - ${
                (gap * (options.length - 1)) / options.length
              }px)`,
            }}
          />
        )}
      </div>
    );
  }
);
